import { useEffect, useState } from 'react';
import {colors, Icon, IconButton, Input, Tooltip} from '@neshane/blueberry';

import { useDebounce } from '../../hooks';

const SEARCH_DELAY_MS = 500;

function SearchFilter({
    search,
    setSearch,
    fit = 'content',
    placeholder = 'جستجو...',
    minLength = 3,
    className = '',
}) {
    const [localSearch, setLocalSearch] = useState(search ?? '');

    useEffect(() => {
        if (search !== localSearch) {
            setLocalSearch(search ?? '');
        }
    }, [search]);

    const debouncedSearch = useDebounce(localSearch, SEARCH_DELAY_MS);

    useEffect(() => {
        if (search === undefined && localSearch === '') {
            return;
        }
        if (
            search !== localSearch &&
            (localSearch.length >= minLength || localSearch.length === 0)
        ) {
            setSearch(localSearch);
        }
    }, [debouncedSearch]);

    return (
        <Tooltip content="پاک کردن را وارد کنید"><div style={{width:"100%"}}><Input
            type="search"
            fit={fit}
            placeholder={placeholder}
            className={`w-[248px] ${className}`}
            textAlign="right"
            onChange={(e) => setLocalSearch(e.target.value)}
            value={localSearch}
            leftAddon={
                <Icon
                    name="magnifying-glass"
                    color={colors.contentDecorativeIcon}
                    className="mr-8"
                    size="m"
                    data-testid="SearchFilterLeftIcon"
                />
            }
            rightAddon={
                localSearch ? (
                    <IconButton
                        iconName="cross"
                        iconColor={colors.contentDecorativeIcon}
                        variant="tertiaryNeutral"
                        onClick={() => {
                            setSearch('');
                            setLocalSearch('');
                        }}
                        data-testid="SearchFilterResetIcon"
                        aria-label="پاک کردن"
                    />
                ) : undefined
            }
            data-testid="SearchFilterInput"
        /></div></Tooltip>
    );
}

export default SearchFilter;